<mat-checkbox [(ngModel)]="checked" [labelPosition]="labelPosition" [disabled]="disabled" color="primary">
  <ng-content></ng-content>
</mat-checkbox>
